import { pushTrackEvent } from '@utiles/officialTopupNew/trackEvent';

// 页面类型
export const pageType = {
  homePage: 'homePage', //首页
  resultPage: 'resultPage', // 储值结果页
  bankPage: 'bankPage', // 银行汇款页
  Mine: 'userCenterPage', // 我的页面(用户中心页)
  browserPay: 'browserPay', // 储值结果跳转页
  channelPage: 'channelPage', // 选渠道页面（确认订单页）
  orderHistoryPage: 'orderHistoryPage' // 订单查询页
};

// 弹窗类型
export const popupType = {
  eventsRulePopup: 'eventsRulePopup', // 限时活动规则弹窗
  confirmRolePopup: 'confirmRolePopup', // 确认领取角色弹窗
  loginPopup: 'loginPopup', // 登录弹窗
  charPopup: 'charPopup', // 角色弹窗
  myCouponPopup: 'myCouponPopup', // 游戏优惠券弹窗
  vipCouponPopup: 'vipCouponPopup', // vip优惠券弹窗
  birthCouponPopup: 'birthCouponPopup', // 生日优惠券弹窗
  paytypeCouponPopup: 'paytypeCouponPopup', // 支付渠道优惠券弹窗
  eventlistPopup: 'eventlistPopup', // 福利弹窗
  aboutCurrencyPopup: 'aboutCurrencyPopup', // 关于代金币弹窗
  safariAddToHomePopup: 'safariAddToHomePopup', // safari添加到主屏幕弹窗
  couponUseCheckPopup: 'couponUseCheckPopup', // 优惠券使用确认弹窗
  pointCardPopup: 'pointCardPopup', // 点卡弹窗
  // paytypeAreaPopup: 'paytypeAreaPopup', // 支付渠道区域弹窗
  productDetailPopup: 'productDetailPopup', // 商品详情弹窗
  productPopup: 'productPopup', // 商品选择弹窗
  errorPaytypePopup: 'errorPaytypePopup', // 支付渠道错误弹窗
  doubleSendPopup: 'doubleSendPopup', // 双倍券弹窗
  coinBalancePopup: 'coinBalancePopup', // 代金币余额不足弹窗
  quickPayCardSelectPopup: 'quickPayCardSelectPopup', // 选择支付卡弹窗

  removeCartProductPopup: 'removeCartProductPopup', //移除购物车商品弹窗
  pwaInstallPopup: 'pwaInstallPopup', // pwa安装弹窗
  pwaBindRolePopup: 'pwaBindRolePopup', // pwa绑定角色弹窗
  rightCenterPopup: 'rightCenterPopup', // 权益中心弹窗
  showProductDetailPopup: 'showProductDetailPopup', // 查看商品详情弹窗
  accountInfoPopup: 'accountInfoPopup', // 帐号功能弹窗
  noticePopup: 'noticePopup', // 跑马灯公告弹窗
  shoppingCartPopup: 'shoppingCartPopup', // 购物车弹窗

  continueSubmit: 'confirmSubmit' // 继续提单提示弹窗
};

// 按钮触发位置
export const locationType = {
  ...pageType,
  ...popupType,
  accountInfo: 'account_info', // 帐号信息模块
  paytypeSection: 'select_channels', // 选择支付渠道模块
  eventList: 'event_list', // 活动列表弹窗
  mainBar: 'mainbar', // 主页功能入口
  selectProduct: 'select_product', // 选择商品模块
  areaLimit: 'change_regions', //切换地区弹窗
  areaLimitConfirm: 'confirm_regions' //确定地区弹窗
};

/**
    页面展示
    key: 页面类型key
*/
export const viewPage = key => {
  pushTrackEvent({
    eventName: 'view_page',
    eventType: pageType[key] || key || ''
  });
};

/**
    弹窗展示
    popupType: 描述弹窗类型
*/
export const showPopup = key => {
  pushTrackEvent({
    eventName: 'show_popup',
    eventType: popupType[key] || key || ''
  });
};

/**
    按钮点击
    btnName: 按钮名称
    reason: 按钮所属模块
*/
export const clickButton = ({ btnName, locationKey, otherParams }) => {
  pushTrackEvent({
    eventName: 'click_button',
    eventType: btnName || '',
    eventReason: locationType[locationKey] || locationKey || '',
    eventValue: otherParams
  });
};

/**
    限时活动打点
   
*/
export const timePoint = ({ activityName, eventValue }) => {
  pushTrackEvent({
    eventName: activityName || '',
    eventType: 'event_list',
    eventValue: eventValue || {}
  });
};

/**
 * AI 支付助手打点（SDK / Chat App 生命周期与交互）
 * @param {{ action: string, category?: string, actor?: string, otherParams?: Object }} params
 */
export const trackPayAssistant = ({
  action,
  category,
  actor,
  otherParams
}) => {
  pushTrackEvent({
    eventType: 'pay_assistant',
    eventName: action || '',
    eventReason: category || '',
    eventValue: {
      actor: actor || 'host',
      ...(otherParams || {})
    }
  });
};
